import { useState } from "react";
import { createContext } from "react"
export const UserConnnectStateContext = createContext();

export const UserConnectStatusProvider = ({children})=>{
    const [isLogin,setIsLogin] = useState(false)  
    const switchIsLogin = ()=>{
        if (isLogin === false) {
            localStorage.setItem('isLogin','true');
            setIsLogin(true);
        }else{
            localStorage.clear();
            setIsLogin(false);
        }
    }
    return(
        <UserConnnectStateContext.Provider value={{isLogin,switchIsLogin}}>
            {children}
        </UserConnnectStateContext.Provider>
    )
}